import React from "react";
import { SkeletonComponents } from ".";
import { SidebarSkeletonProps } from "@/shared/type/skeleton.type";

const SidebarSkeleton = ({
  collapsed = false,
  itemCount = 8,
}: SidebarSkeletonProps): React.ReactElement => {
  return (
    <aside
      className={`sidebar ${collapsed ? "sidebar-close" : "sidebar-open"}`}
      aria-hidden="true"
    >
      <ul className="space-y-3 md:pl-5 md:pr-2 overflow-x-visible overflow-y-auto pt-5 max-h-[calc(100vh-80px)]">
        {Array.from({ length: itemCount }, (_, index) => (
          <li key={index} className="relative side-link">
            <div
              className={`min-h-11 bg-white flex items-center gap-3 p-3 rounded-[62px] ${collapsed ? "justify-center" : ""}`}
            >
              <SkeletonComponents.skeleton className="size-5 flex-none rounded-md" />
              {!collapsed && (
                <>
                  <SkeletonComponents.skeleton
                    className={`h-4 ${index % 3 === 0 ? "w-28" : "w-24"}`}
                  />
                  <SkeletonComponents.skeleton className="ml-auto size-3 rounded-sm" />
                </>
              )}
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default SidebarSkeleton;
